import * as React from "react";

export class FreeBet extends React.Component<{
    text: string
    isActive: boolean
    toggleStakeType: (MouseEvent) => void
}, {}> {

    renderText() {
        return (
            <div className="rj-freebet__wrapper">
                <div className="rj-freebet__text" onClick={this.props.toggleStakeType}>
                    {this.props.text}
                </div>
                <div className="rj-freebet__right-side"></div>
            </div>
        )
    }

    render() {
        return (
            this.props.isActive && this.renderText()
        )
    }
}